import { render, staticRenderFns } from "./BankAccountView.vue?vue&type=template&id=e86478f4&scoped=true&"
import script from "./BankAccountView.vue?vue&type=script&lang=js&"
export * from "./BankAccountView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86478f4",
  null
  
)

export default component.exports